<div class="datepicker-wrapper" [class.fullscreen]="isMobile && isOpen">
  <details class="dropdown dropdown-end" #dropdown>
    <summary [class]="buttonClasses">
      <span class="flex items-center gap-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
        <span>{{ formattedValue || placeholder }}</span>
      </span>
    </summary>
    <div #dropdownContent class="dropdown-content menu p-4 shadow-lg bg-base-100 rounded-box border border-base-300">
      <!-- Cally Calendar -->
      <calendar-date
        #calendarDate
        class="cally bg-base-100 rounded-box"
        [value]="calendarValue"
        [min]="minDateStr"
        [max]="maxDateStr">
        <svg aria-label="Previous" class="fill-current size-4" slot="previous" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="currentColor" d="M15.75 19.5 8.25 12l7.5-7.5"></path>
        </svg>
        <svg aria-label="Next" class="fill-current size-4" slot="next" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path fill="currentColor" d="m8.25 4.5 7.5 7.5-7.5 7.5"></path>
        </svg>
        <calendar-month></calendar-month>
      </calendar-date>

      <!-- Actions -->
      <div class="flex gap-2 mt-4">
        <button type="button" class="btn btn-sm flex-1" (click)="closeDropdown()">
          Cancel
        </button>
        @if (selectedDate) {
          <button type="button" class="btn btn-sm btn-ghost flex-1" (click)="clear()">
            Clear
          </button>
        }
      </div>
    </div>
  </details>
</div>




